import { decodeOneOf, encodeOneOf, safeId } from '../../../../domain';
import { intervalOf } from './user-base.types';
import { RestrictedKeys } from '../restricted.key';
import { Places } from '../../../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'ub';
/** Os parametros deste place: vao para o endereco. */
const P = {
    Preset: `${PREFIX}a`,
    UserBaseStart: `${PREFIX}b`,
    UserBaseEnd: `${PREFIX}c`,
    Granularity: `${PREFIX}d`,
    UserBaseCompany: `${PREFIX}e`
};
/*
 * Os codigos desta tela no endereco.
 *
 * Moram aqui, e nao em `domain`, porque `Preset` e `Granularity` sao parametros
 * DESTA tela e de mais nenhuma. Ver a nota sobre onde uma tabela de codigo mora,
 * em `domain/index.ts`.
 */
/** O codigo de cada atalho de periodo. */
export const PRESET_CODES = {
    '0': '30d',
    '1': '90d',
    '2': '12m',
    '3': 'year',
    '4': 'custom'
};
/** O codigo de cada granularidade. */
export const GRANULARITY_CODES = {
    '0': 'DAY',
    '1': 'MONTH'
};
/**
 * Os seis filtros de Adocao e Engajamento.
 *
 * Todos eram `useState` no painel antigo. O atalho de periodo (`30d`, `90d`, ...) e
 * o que o leitor escolhe; as datas e a granularidade sao DERIVADAS dele, exceto no
 * modo `custom`, onde e o contrario.
 *
 * Por isso `startDate` e `endDate` so aparecem no endereco quando ha um intervalo
 * digitado: repetir na URL o que o atalho ja diz seria ruido, e pior, poderia
 * discordar dele.
 */
export class UserBaseKeys extends RestrictedKeys {
    get place() {
        return Places.userBase;
    }
    // :: atalho de periodo
    /**
     * Se o ENDERECO diz um periodo. Quando nao diz, vale o ultimo periodo escolhido no
     * painel (B-35, `recallPeriod`), e nao o padrao fixo desta tela.
     */
    get periodInAddress() {
        return (this._intent.getParameterAsString(P.Preset) !== undefined ||
            this._intent.getParameterAsString(P.UserBaseStart) !== undefined ||
            this._intent.getParameterAsString(P.UserBaseEnd) !== undefined);
    }
    get preset() {
        return decodeOneOf(this._intent.getParameterAsString(P.Preset), PRESET_CODES, '30d');
    }
    set preset(value) {
        this._intent.setParameter(P.Preset, value === '30d' ? undefined : encodeOneOf(value, PRESET_CODES));
    }
    // :: intervalo
    /** Lido do atalho, ou do endereco quando o atalho e `custom`. */
    get startDate() {
        return this._intent.getParameterAsString(P.UserBaseStart) ?? intervalOf(this.preset)?.startDate ?? '';
    }
    set startDate(value) {
        this._intent.setParameter(P.UserBaseStart, this.preset === 'custom' ? value : undefined);
    }
    get endDate() {
        return this._intent.getParameterAsString(P.UserBaseEnd) ?? intervalOf(this.preset)?.endDate ?? '';
    }
    set endDate(value) {
        this._intent.setParameter(P.UserBaseEnd, this.preset === 'custom' ? value : undefined);
    }
    get granularity() {
        const implied = intervalOf(this.preset)?.granularity ?? 'DAY';
        return decodeOneOf(this._intent.getParameterAsString(P.Granularity), GRANULARITY_CODES, implied);
    }
    set granularity(value) {
        // So vale a pena publicar quando diverge do que o atalho implica.
        const implied = intervalOf(this.preset)?.granularity;
        this._intent.setParameter(P.Granularity, value === implied ? undefined : encodeOneOf(value, GRANULARITY_CODES));
    }
    // :: empresa
    get companyId() {
        return safeId(this._intent.getParameterAsNumber(P.UserBaseCompany));
    }
    set companyId(value) {
        this._intent.setParameter(P.UserBaseCompany, value);
    }
}
//# sourceMappingURL=user-base.key.js.map